/**
 * DE translations — generated by scripts/build-locale-translations.mjs.
 * Keys marked '// @en' still return the English string; run the
 * generator after a translation pass to update this file.
 */
export const de = {
  "nav.home": "Startseite",
  "nav.about": "Über uns",
  "nav.products": "Produkte",
  "nav.capabilities": "Kompetenzen",
  "nav.quality": "Qualität & Compliance",
  "nav.news": "Neuigkeiten",
  "nav.contact": "Kontakt",
  "header.phone": "Telefon",
  "header.email": "E-Mail",
  "header.rfq_cart": "Warenkorb",
  "button.request_quote": "Angebot anfordern",
  "search.placeholder": "Suche nach CAS-Nr. oder Produktname",
  "language.change": "Sprache ändern",
  "hero.badge": "ISO 9001:2015 zertifizierte Qualität",
  "hero.title.leading": "Führende",
  "hero.title.pharmaceutical": "pharmazeutische",
  "hero.title.innovation": "Innovation",
  "hero.description": "Longshine Boi-Tech liefert Premium-APIs, pharmazeutische Zwischenprodukte und Veterinärverbindungen an globale Märkte, mit ISO-zertifizierter Qualitätssicherung aus unseren Anlagen in Indien.",
  "hero.button.explore": "Produkte erkunden",
  "hero.button.quote": "Angebot anfordern",
  "hero.stats.countries": "Belieferte Länder",
  "hero.stats.products": "Aktive Produkte",
  "hero.stats.years": "Jahre Exzellenz",
  "categories.title": "Premium-Pharmazielösungen",
  "categories.subtitle": "Entdecken Sie unser umfassendes Sortiment an APIs, Zwischenprodukten und Spezialverbindungen, hergestellt nach höchsten internationalen Standards.",
  "categories.search.placeholder": "Search by CAS Number, Product Name, or Category...", // @en
  "categories.human_apis.title": "Humane APIs",
  "categories.human_apis.description": "Pharmazeutische Wirkstoffe für die Humantherapie mit vollständiger regulatorischer Dokumentation.",
  "categories.intermediates.title": "Zwischenprodukte",
  "categories.intermediates.description": "Hochwertige pharmazeutische Zwischenprodukte und Bausteine für die Wirkstoffsynthese.",
  "categories.veterinary.title": "Veterinär-APIs",
  "categories.veterinary.description": "Spezialverbindungen für Tiergesundheit und veterinärpharmazeutische Anwendungen.",
  "categories.products_count": "+ Produkte",
  "featured.title": "Empfohlene Produkte",
  "featured.subtitle": "Entdecken Sie unsere beliebtesten pharmazeutischen Verbindungen, denen Hersteller weltweit vertrauen.",
  "featured.view_all": "Alle Produkte anzeigen",
  "features.title": "Warum Longshine Boi-Tech",
  "features.subtitle": "Decades of pharmaceutical know-how plus current-generation process technology — delivering APIs and intermediates that hold up against any global standard.", // @en
  "features.iso.title": "ISO 9001:2015 zertifiziert",
  "features.iso.description": "Internationally recognized quality management system ensuring consistent excellence in all our processes and products.", // @en
  "features.global.title": "Globale Lieferkette",
  "features.global.description": "Reliable worldwide distribution network serving pharmaceutical companies across 50+ countries with timely delivery.", // @en
  "features.compliance.title": "Regulatorische Compliance",
  "features.compliance.description": "Full compliance with FDA, EMA, and other international regulatory standards for pharmaceutical manufacturing.", // @en
  "features.custom.title": "Auftragsfertigung",
  "features.custom.description": "Flexible CMO/CDMO services for custom synthesis, scale-up production, and specialized pharmaceutical compounds.", // @en
  "features.team.title": "Expertenteam",
  "features.team.description": "Experienced R&D professionals and regulatory experts dedicated to delivering innovative pharmaceutical solutions.", // @en
  "features.facilities.title": "Moderne Anlagen",
  "features.facilities.description": "Modern manufacturing facilities with current-generation process equipment and validated quality control systems.", // @en
  "cta.title": "Bereit für eine Partnerschaft?",
  "cta.subtitle": "Schließen Sie sich hunderten globalen Pharmaunternehmen an, die Longshine Boi-Tech für ihre API- und Zwischenprodukt-Versorgung vertrauen.",
  "cta.quote_now": "Jetzt Angebot anfordern",
  "cta.download_catalog": "Katalog herunterladen",
  "product.cas": "CAS",
  "product.moq": "MOQ",
  "product.bulk_discount": "Mengenrabatt verfügbar",
  "product.details": "Details",
  "product.sds": "SDB",
  "product.add_rfq": "In Warenkorb",
  "product.download_started": "Download Started", // @en
  "product.sds_downloading": "Safety Data Sheet for {product} is downloading", // @en
  "product.download_error": "Download Error", // @en
  "product.sds_error": "Could not download SDS for {product}. Please contact support.", // @en
  "product.added_rfq": "Zum Warenkorb hinzugefügt",
  "product.added_cart": "{product} wurde Ihrem Warenkorb hinzugefügt",
  "product.view_cart": "Warenkorb ansehen",
  "about.hero.title": "About Longshine Boi-Tech", // @en
  "about.hero.description": "Since 2009, we have been at the forefront of pharmaceutical innovation, delivering premium APIs and intermediates that meet the highest global standards while building trusted partnerships with manufacturers worldwide.", // @en
  "about.hero.years": "15+ Years of Excellence", // @en
  "about.hero.global": "Global Reach", // @en
  "about.story.title": "Our Story", // @en
  "about.story.p1": "Longshine Boi-Tech was founded in 2009 with a vision to bridge the gap between innovative pharmaceutical research and reliable global supply. Starting as a small research facility in Pune, Maharashtra, we have grown into a leading manufacturer of pharmaceutical active ingredients.", // @en
  "about.story.p2": "Our commitment to quality and regulatory compliance has enabled us to build long-term partnerships with pharmaceutical companies across six continents. Every product we manufacture undergoes rigorous testing and quality assurance to ensure it meets international pharmaceutical standards.", // @en
  "about.story.p3": "Today, Longshine Boi-Tech is recognized as a trusted supplier of premium APIs, intermediates, and veterinary compounds, with ISO 9001:2015 certification and multiple regulatory approvals including FDA DMFs and European CEPs.", // @en
  "about.journey.title": "Our Journey", // @en
  "about.journey.subtitle": "Key milestones that shaped our growth", // @en
  "about.leadership.title": "Leadership Team", // @en
  "about.leadership.subtitle": "Experienced professionals driving our success", // @en
  "about.leadership.rajesh.name": "Dr. Rajesh Kumar", // @en
  "about.leadership.rajesh.position": "CEO & Founder", // @en
  "about.leadership.rajesh.background": "Former pharmaceutical research director with 20+ years experience in API development and regulatory affairs across India and global markets.", // @en
  "about.leadership.priya.name": "Dr. Priya Sharma", // @en
  "about.leadership.priya.position": "Chief Technology Officer", // @en
  "about.leadership.priya.background": "PhD in Pharmaceutical Chemistry from IIT Mumbai, expert in process optimization and quality assurance systems with international certifications.", // @en
  "about.leadership.amit.name": "Amit Patel", // @en
  "about.leadership.amit.position": "VP of Global Sales", // @en
  "about.leadership.amit.background": "International business development leader with extensive experience in pharmaceutical supply chains and strategic partnerships across APAC and European markets.", // @en
  "about.milestone.2009": "Company founded in Pune, Maharashtra, India", // @en
  "about.milestone.2012": "ISO 9001:2015 certification achieved", // @en
  "about.milestone.2015": "First international API exports", // @en
  "about.milestone.2018": "FDA DMF submissions approved", // @en
  "about.milestone.2020": "Expanded to veterinary APIs", // @en
  "about.milestone.2023": "Serving 50+ countries globally", // @en
  "about.values.title": "Our Values", // @en
  "about.values.subtitle": "The principles that guide everything we do", // @en
  "about.values.excellence.title": "Excellence", // @en
  "about.values.excellence.description": "We pursue the highest standards in everything we do, from product quality to customer service, ensuring consistent excellence in all our operations.", // @en
  "about.values.integrity.title": "Integrity", // @en
  "about.values.integrity.description": "Transparency, honesty, and ethical business practices form the foundation of our relationships with customers, suppliers, and regulatory bodies.", // @en
  "about.values.innovation.title": "Innovation", // @en
  "about.values.innovation.description": "Continuous improvement and ongoing process research are how we keep developing better products and tighter manufacturing routes.", // @en
  "about.cta.title": "Ready to Partner with Us?", // @en
  "about.cta.subtitle": "Discover how Longshine Boi-Tech can support your pharmaceutical manufacturing needs with our premium APIs and exceptional service.", // @en
  "about.cta.products": "View Our Products", // @en
  "about.cta.contact": "Contact Our Team", // @en
  "contact.hero.title": "Kontakt",
  "contact.hero.description": "Ready to partner with us? Our global team of pharmaceutical experts is here to support your API and intermediate supply requirements with personalized service and technical expertise.", // @en
  "contact.hero.support": "24/7 Customer Support", // @en
  "contact.hero.presence": "Global Presence", // @en
  "contact.form.title": "Senden Sie uns eine Nachricht",
  "contact.form.additional": "Additional Information", // @en
  "contact.form.subtitle": "Fill out the form below and our team will get back to you within 24 hours.", // @en
  "contact.form.order_subtitle": "Provide any additional requirements or special instructions for your order.", // @en
  "contact.form.first_name": "Vorname",
  "contact.form.last_name": "Nachname",
  "contact.form.email": "E-Mail-Adresse",
  "contact.form.phone": "Telefonnummer",
  "contact.form.company": "Firmenname",
  "contact.form.country": "Land",
  "contact.form.inquiry_type": "Inquiry Type", // @en
  "contact.form.message": "Nachricht",
  "contact.form.files": "Attach Files (Optional)", // @en
  "contact.form.upload_text": "Click to upload or drag and drop", // @en
  "contact.form.upload_formats": "Supported formats: PDF, DOC, XLS (Max 10MB)", // @en
  "contact.form.consent": "I agree to the processing of my personal data and consent to receive marketing communications from Longshine Boi-Tech. You can unsubscribe at any time.", // @en
  "contact.form.send": "Nachricht senden",
  "contact.form.submit_additional": "Submit Additional Information", // @en
  "contact.form.placeholder.first_name": "Enter your first name", // @en
  "contact.form.placeholder.last_name": "Enter your last name", // @en
  "contact.form.placeholder.email": "Enter your email", // @en
  "contact.form.placeholder.phone": "Enter your phone number", // @en
  "contact.form.placeholder.company": "Enter your company name", // @en
  "contact.form.placeholder.country": "Select your country", // @en
  "contact.form.placeholder.message": "Please provide details about your inquiry, including specific products of interest, quantities, and any technical requirements...", // @en
  "contact.form.placeholder.message_order": "Please provide any special requirements, delivery instructions, or additional information for your order...", // @en
  "contact.quick.title": "Quick Contact", // @en
  "contact.quick.main_office": "Main Office", // @en
  "contact.quick.general": "General Inquiries", // @en
  "contact.quick.headquarters": "Headquarters", // @en
  "contact.response.title": "Response Times", // @en
  "contact.crypto.title": "Crypto Payment Support", // @en
  "contact.crypto.description": "Need help with your cryptocurrency payment? Our crypto payment specialists are available 24/7.", // @en
  "contact.crypto.support": "Get Crypto Support", // @en
  "contact.payment.complete_order": "Complete Your Order", // @en
  "contact.payment.review_items": "Review your cart items and choose your preferred payment method. We accept major cryptocurrencies for fast, secure transactions.", // @en
  "contact.payment.crypto": "Cryptocurrency", // @en
  "contact.payment.bank": "Bank Transfer", // @en
  "contact.payment.traditional": "Traditional Payment Methods", // @en
  "contact.payment.bank_desc": "For bank transfers and traditional payment methods, please contact our sales team for detailed payment instructions.", // @en
  "contact.payment.contact_sales": "Contact Sales for Payment Details", // @en
  "products.hero.human_apis": "Humane APIs",
  "products.hero.intermediates": "Pharmazeutische Zwischenprodukte",
  "products.hero.veterinary": "Veterinär-APIs",
  "products.hero.catalog": "Produktkatalog",
  "products.hero.human_desc": "High-quality active pharmaceutical ingredients for human medicine, manufactured to international standards with comprehensive regulatory support.", // @en
  "products.hero.intermediates_desc": "Pharmaceutical intermediates and building blocks for drug synthesis — tight purity targets and a reliable supply track record.", // @en
  "products.hero.veterinary_desc": "Specialized active ingredients for veterinary applications, ensuring animal health and well-being with proven efficacy.", // @en
  "products.hero.catalog_desc": "Discover our comprehensive range of pharmaceutical active ingredients, intermediates, and veterinary compounds manufactured to international standards.", // @en
  "products.hero.available": "+ Products Available", // @en
  "products.search.placeholder": "Search by CAS Number, Product Name, or Keyword...", // @en
  "products.filter.by": "Filter by:", // @en
  "products.filter.category": "Kategorie",
  "products.filter.availability": "Verfügbarkeit",
  "products.filter.advanced": "Advanced Filters", // @en
  "products.filter.export": "Export Catalog", // @en
  "products.showing": "{count} Produkte werden angezeigt",
  "products.results.all": "Alle Produkte",
  "products.sort.relevance": "Relevanz",
  "products.sort.name": "Name A-Z",
  "products.sort.category": "Kategorie",
  "products.sort.availability": "Verfügbarkeit",
  "footer.company": "Longshine Boi-Tech Co., Ltd.",
  "footer.certified": "ISO 9001:2015 zertifizierte Qualität",
  "footer.description": "Leading pharmaceutical manufacturer delivering premium APIs, intermediates, and veterinary compounds to global markets with uncompromising quality.", // @en
  "footer.products": "Produkte",
  "footer.company_links": "Unternehmen",
  "footer.human_apis": "Humane APIs",
  "footer.intermediates": "Zwischenprodukte",
  "footer.veterinary": "Veterinär-APIs",
  "footer.all_products": "Alle Produkte",
  "footer.about": "Über uns",
  "footer.capabilities": "Kompetenzen",
  "footer.quality": "Qualität & Compliance",
  "footer.contact": "Kontakt",
  "footer.copyright": "© 2026 Longshine Boi-Tech Pvt. Ltd. Alle Rechte vorbehalten.",
  "common.search": "Suchen",
  "common.categories.all": "Alle Kategorien",
  "common.categories.human": "Humane APIs",
  "common.categories.intermediates": "Zwischenprodukte",
  "common.categories.veterinary": "Veterinär-APIs",
  "common.availability.all": "Alle Verfügbarkeit",
  "common.availability.in_stock": "Auf Lager",
  "common.availability.on_demand": "Auf Anfrage",
  "common.availability.custom": "Individuell",
  "common.loading": "Wird geladen...",
  "common.error": "Fehler",
  "common.success": "Erfolg",
};
